import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nProvider } from 'react-aria-components/I18nProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import AppsPlaceholderPage from './app/AppsPlaceholderPage';
import App from './app/App';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('No se encontró el contenedor principal de la aplicación.');

// app.accesible.club todavía no tiene su propio catálogo de aplicaciones:
// muestra un cartel fijo en vez del sitio completo, sin sesión ni router —
// ver el docstring de AppsPlaceholderPage para el porqué de esta excepción.
const isAppsPlaceholder = window.location.hostname === 'app.accesible.club';

createRoot(root).render(
  <StrictMode>
    <I18nProvider locale="es-ES">
      {isAppsPlaceholder ? <AppsPlaceholderPage /> : <App />}
    </I18nProvider>
  </StrictMode>,
);
